const PRIORITY_LEVEL = {
    BASE: 'base',
    POP_UP: 'popup',
    OPEN_SESSION: 'open-session',
    FP: 'fp',
    OMG_BEHIND: 'omg-behind',
    GAME_FRAME: 'game-frame',
    NEXT_GAME: 'next-game',
    GAME_LOADING_INDICATOR: 'game-loading-indicator',
    GAME_FRAME_LOADER: 'game-frame-loader',
    GAME_FRAME_FP: 'game-frame-fp',
    MINI_CASHIER: 'mini-cashier',
    CASHIER: 'cashier',
    LOGIN: 'login',
    EXTERNAL_LINK: 'external-link',
    INTERNAL_OVER_EXTERNAL_LINK: 'internal-over-external-link',
    OMG: 'omg',
    GEO_FREEZE_WINDOW: 'geo-freeze-window',
    TEMP_ACCOUNT: 'temp-account',
    MEMBERSHIP: 'membership',
    MESSAGE: 'message',
    SECONDARY_MESSAGE: 'secondary-message',
    TOUCH_ID: 'touch-id',
    TOUCH_ID_POPUP: 'touch-id-popup',
    LOCK: 'lock',
    SPAIN_SUMMARY_MESSAGE: 'spain-summary-message',
    GAMES_QUESTIONNAIRE: 'games-questionnaire'
    // MEMBERSHIP: 'membership'
};


const PRIORITY_LEVEL_ZINDEX_MAPPER = {
    [PRIORITY_LEVEL.BASE]: 8000,
    [PRIORITY_LEVEL.POP_UP]: 8010,
    [PRIORITY_LEVEL.OPEN_SESSION]: 8020,
    [PRIORITY_LEVEL.FP]: 8030,
    [PRIORITY_LEVEL.OMG_BEHIND]: 8035,
    [PRIORITY_LEVEL.GAME_LOADING_INDICATOR]: 8037,
    [PRIORITY_LEVEL.NEXT_GAME]: 8038,
    [PRIORITY_LEVEL.GAME_FRAME]: 8040,
    [PRIORITY_LEVEL.GAME_FRAME_FP]: 8041,
    [PRIORITY_LEVEL.GAME_FRAME_LOADER]: 8042,
    [PRIORITY_LEVEL.MINI_CASHIER]: 8045,
    [PRIORITY_LEVEL.LOGIN]: 8050,
    [PRIORITY_LEVEL.SPAIN_SUMMARY_MESSAGE]: 8055,
    [PRIORITY_LEVEL.EXTERNAL_LINK]: 8060,
    [PRIORITY_LEVEL.INTERNAL_OVER_EXTERNAL_LINK]: 8061,
    [PRIORITY_LEVEL.OMG]: 8070,
    [PRIORITY_LEVEL.CASHIER]: 8072,
    [PRIORITY_LEVEL.GAMES_QUESTIONNAIRE]: 8073,
    [PRIORITY_LEVEL.GEO_FREEZE_WINDOW]: 8074,
    [PRIORITY_LEVEL.TEMP_ACCOUNT]: 8075,
    [PRIORITY_LEVEL.MEMBERSHIP]: 8078,
    [PRIORITY_LEVEL.MESSAGE]: 8080,
    [PRIORITY_LEVEL.SECONDARY_MESSAGE]: 8082,
    [PRIORITY_LEVEL.TOUCH_ID]: 8090,
    [PRIORITY_LEVEL.TOUCH_ID_POPUP]: 9002,
}

const WRAPPER_DEFAULT_INDEX = 7999;

export { PRIORITY_LEVEL, PRIORITY_LEVEL_ZINDEX_MAPPER, WRAPPER_DEFAULT_INDEX };
